module.exports = __webpack_public_path__ + "img/ezugi.02838224.jpg";